import { render, staticRenderFns } from "./CaseLife.vue?vue&type=template&id=131faf9c"
import script from "./CaseLife.vue?vue&type=script&lang=js"
export * from "./CaseLife.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports